// src/services/customModelService.js — BYOM custom model endpoints
import axios from 'axios';
import { API_CONFIG } from '../config/api';

const API_BASE_URL = API_CONFIG.BASE_URL;

const api = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('authToken');
  if (!token) throw new Error('No authentication token found. Please login again.');
  return axios.create({
    baseURL: API_BASE_URL,
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  });
};

const handle = (error, op) => {
  const detail = error.response?.data?.detail;
  if (error.response?.status === 401) throw new Error('Authentication failed.');
  if (detail) throw new Error(Array.isArray(detail) ? detail.map(e => e.msg || JSON.stringify(e)).join('; ') : detail);
  throw new Error(`${op} failed: ${error.message}`);
};

export const customModelService = {
  list: async () => {
    try { return (await api().get('/api/user-models')).data; }
    catch (e) { handle(e, 'List models'); }
  },

  create: async ({ name, model_id, base_url, api_key }) => {
    try { return (await api().post('/api/user-models', { name, model_id, base_url, api_key })).data; }
    catch (e) { handle(e, 'Create model'); }
  },

  update: async (id, updates) => {
    try { return (await api().put(`/api/user-models/${id}`, updates)).data; }
    catch (e) { handle(e, 'Update model'); }
  },

  delete: async (id) => {
    try { return (await api().delete(`/api/user-models/${id}`)).data; }
    catch (e) { handle(e, 'Delete model'); }
  },

  test: async ({ base_url, api_key }) => {
    try { return (await api().post('/api/user-models/test', { base_url, api_key })).data; }
    catch (e) { handle(e, 'Test connection'); }
  },
};
